module.exports = __webpack_public_path__ + "static/media/logo.c271c8b8.png";